import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import APCurrencyIconStyles from './styles/APCurrencyIcon.style';
import { GetCurrenciesFlagIcon } from '../../../core/utils/GetCurrenciesData';

interface APCurrencyIconProps extends WithStyles<typeof APCurrencyIconStyles> {
    currency: string,
}

class APCurrencyIcon extends Component<APCurrencyIconProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            image: ''
        }
    }

    async getIcon(currency: string) {
        const flagIcon = await GetCurrenciesFlagIcon(currency);
        if (flagIcon.default) {
            this.setState({ image: flagIcon.default });
        }
    }

    componentDidMount(): void {
        const {
            currency
        } = this.props;

        if (currency) {
            this.getIcon(currency);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currency !== this.props.currency) {
            this.getIcon(this.props.currency);
        }
    }

    render() {

        const {
            classes
        } = this.props;

        return (
            <span className={classes.itemIcon}>
                <img src={this.state.image} alt="Currency icon"/>
            </span>
        )
    }
}

export default withStyles(APCurrencyIconStyles)(APCurrencyIcon);
